// src/components/DemandResponseTable.tsx
import * as React from 'react';
import './styles.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Padding } from '@mui/icons-material';
import { openResources } from '../authConfig';

type Plan = {
  id: number;
  dateTime: string;
  message: string;
  isDemandResponseExpected: boolean;
  enabled: boolean;
}

interface DemandResponsePlanProps {
  numPlans?: number;
}

const DemandResponsePlan: React.FC<DemandResponsePlanProps> = ({ numPlans }) => {

  const [data, setData] = useState<Plan[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  //const baseUrl = 'https://api.minnkota.com';
  //const endpoint = '/demandresponse/ripple/plans';
  const param = numPlans ? `?numPlans=${numPlans}` : '';
  
  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
        try {            
          //`${baseUrl}${endpoint}${param}`
          const response = await axios.get(openResources.ripplePlans.endpoint, {});
          //console.log(response.data);
          if (response.data && Array.isArray(response.data)) {
            const adaptedData: Plan[] = response.data.map((item: any) => ({
              id: item.id,
              dateTime: item.dateTime,
              message: item.message,
              isDemandResponseExpected: item.isDemandResponseExpected,
              enabled: item.enabled
            }));
            setData(adaptedData);
          } else {
            setData([]);
          }    
          
        } catch (error: any) {
            setError('Error fetching data: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    fetchData();
}, [param]);

  return (
    <div>
      <h2>{numPlans === 1 ? 'Demand Response Plan' : 'Demand Response Plans'}</h2>
      {loading && <p>Loading...</p>}
      {error && <p>{error}</p>}
      {!loading && !error && data.map((message, index) => (
        <div key={index} className="message-container" style={{ marginLeft: '100px', marginRight: '100px'}}>
            <h3>{new Date(message.dateTime).toLocaleDateString('en-US')} </h3>
            <p style={{marginTop: -7, marginBottom: 5}}>{new Date(message.dateTime).toLocaleTimeString('en-US')}</p>
          <p>{message.message}</p>
        </div>
      ))}
    </div>
  );
};

export default DemandResponsePlan;